import React from 'react';
import ReactDOM from 'react-dom';
import Bugsnag from '@bugsnag/js';
import BugsnagPluginReact from '@bugsnag/plugin-react';

import { Provider } from 'react-redux';
import { Router } from 'react-router-dom';
import configureStore from './store/configure';
import history from './history';

import App from './App/index';

import * as serviceWorker from './serviceWorker';

import config from './config';

/* Inicializa o bugsnag */
Bugsnag.start({
	apiKey: '8b6e27f49f34f38d72537d2a5773dfd9',
	plugins: [new BugsnagPluginReact()]
});
const ErrorBoundary = Bugsnag.getPlugin('react').createErrorBoundary(React);

/* configuração do Store */
const store = configureStore();

/* Inicializa a aplicação */
const app = (
	<Provider store={store}>
		<Router basename={config.basename} history={history}>
			<ErrorBoundary>
				<App />
			</ErrorBoundary>
		</Router>
	</Provider>
);

ReactDOM.render(app, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
